export default "__VITE_ASSET__8ae036d4__"